module.exports = {"langUnavailable":{"title":"Esta página não está disponível no seu idioma","body":"Deseja continuar a navegar ou visualizar a página inicial?","dismiss":"Fechar este aviso e continuar a navegar","close":"Fechar","navigate":"Página inicial"},"langRecommendation":{"title":"A sua preferência de idioma está configurada para Português. Gostaria de visitar o website em Português?","navigate":"Sim","close":"Não"}}


//////////////////
// WEBPACK FOOTER
// ./scripts/routes/translations/pt.json
// module id = 85
// module chunks = 0